<template>
  <section class="section process">
    <ProcessCardsMobile
      v-if="isMovil"
      :processes="processes"
      @select="selected"
      @toggle="toggleActive"
      @edit="editProcess"
      @comparison="selectedComp"
      @copy-link="copyLinkProcess"
      @delete="deleteProcess"
      @create="closeMenuCreate"
    ></ProcessCardsMobile>
    <table-ag
      v-else
      :if="processes"
      :rowData="processes"
      :columnDefs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      :typeSelection="'single'"
      :pagination="false"
      :auto-height="true"
      @selected="selected"
    ></table-ag>

    <!-- Components -->
    <transition name="slideCustom">
      <MenuCreateProcess
        v-if="showMenuCreate"
        type="cl7"
        :data="processEdit"
        :hasBenchmark="hasBenchmark"
        @closeMenuCreate="closeMenuCreate"
        @getProcesses="getProcesses"
      >
      </MenuCreateProcess>
    </transition>
    <ModalComparacionHistorico
      ref="modalCompClima"
      :show="showModalCom"
      :process="process"
      :listProcesses="processes"
      @closeModalComp="closeModalComp"
      @saveHistoric="saveHistoric"
      @deleteComparison="deleteComparison"
    ></ModalComparacionHistorico>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import tableAg from "../dashboard/tableAg.vue";
import { mapState } from "vuex";
import MenuCreateProcess from "../lideres/components/menuCreateProcess.vue";
import ModalComparacionHistorico from "../climan/components/ModalComparacionHistorico.vue";
import buttonsActionProcess from "../climan/components/buttonsActionProcess.vue";
import menuTableProcess from "../climan/components/menuTableProcess.vue";
import ProcessCardsMobile from "../climan/components/ProcessCardsMobile.vue";

export default {
  data() {
    return {
      processes: [],
      process: {},
      processEdit: {},
      columns: [
        {
          field: "nombre",
          headerName: "Proceso",
          editable: false,
          cellRenderer: (params) => {
            return `${this.formatTypeProcess(params)} ${params.value}`;
          },
        },
        {
          field: "historic",
          headerName: "Histórico",
          cellRenderer: (params) => {
            return this.formatStatusComp(params.value);
          },
          editable: false,
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipValueGetter: (params) => {
            if (!params.value || !params.value.length) return null;
            return params.value.map((p) => p.nombre).join(" · ");
          },
        },
        {
          field: "codigo",
          headerName: "Código",
          editable: false,
          width: 20,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "created",
          headerName: "Creado",
          editable: false,
          cellRenderer: (params) => {
            return this.dateProcess(params.value);
          },
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          width: 100,
          cellRenderer: "ButtonsActionProcessClim",
        },
      ],
      components: {
        ButtonsActionProcessClim: () => {
          return {
            render: (h) =>
              h(buttonsActionProcess, {
                props: {},
                on: {
                  editProcess: this.editProcess,
                  selectedComp: this.selectedComp,
                  getProcesses: this.getProcesses,
                },
              }),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableProcess, {
              props: {},
              on: {
                closeMenuCreate: this.closeMenuCreate,
              },
            }),
        };
      },
      showModalCom: false,
      showMenuCreate: false,
    };
  },
  computed: {
    ...mapState(["idtoken", "isMovil"]),
    hasBenchmark() {
      return this.processes.some((x) => x.benchmark === 1);
    },
  },
  beforeMount() {},
  methods: {
    // Table
    async getProcesses() {
      try {
        const result = await apiServices.get(`/listcohorteclima`);
        if (result.data) {
          this.processes = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Selección de fila (tabla ag-Grid en escritorio, tarjetas en móvil). Sólo
    // navega: guardar el histórico es responsabilidad de `saveHistoric`.
    selected(proceso) {
      const comparison = proceso.comparison ? proceso.comparison : {};
      this.$emit("selproceso", proceso, comparison);
    },
    async saveHistoric(proceso, historic) {
      try {
        const result = await apiServices.post("saveCompProcessClima", {
          idProcess: proceso._id,
          historic,
        });

        if (result.data) {
          const guardados = result.data.historic
            ? result.data.historic.length
            : 0;
          // El backend descarta ids que no cumplen (otra empresa, o posteriores al
          // ancla). Se avisa en vez de mostrar un guardado silenciosamente parcial.
          const descartados = result.data.discarded || 0;
          await this.$swal({
            html:
              `Histórico guardado con <span class="has-text-weight-bold">${guardados}</span> ` +
              `proceso${guardados === 1 ? "" : "s"} de comparación.` +
              (descartados > 0
                ? `<br><br>Se descartó${descartados === 1 ? "" : "n"} ` +
                  `${descartados} proceso${descartados === 1 ? "" : "s"} por no ser ` +
                  "anterior al proceso actual."
                : ""),
            icon: "success",
          });
          await this.getProcesses();
          // Reapunta al documento recién leído: si no, `this.process` seguiría
          // teniendo el histórico anterior al reabrir el modal.
          const fresh = this.processes.find((p) => p._id === proceso._id);
          if (fresh) this.process = fresh;
          this.closeModalComp();
        } else {
          await this.$swal({
            text: "Error al guardar el histórico de comparación.",
            icon: "error",
          });
        }
      } catch (err) {
        console.log(err);
        await this.$swal({
          text: "Error al guardar el histórico de comparación.",
          icon: "error",
        });
      }
    },
    selectedComp(proc) {
      this.process = proc;
      this.closeModalComp();
    },
    // Modals or Components
    closeModalComp() {
      this.showModalCom = !this.showModalCom;
    },
    closeMenuCreate() {
      this.showMenuCreate = !this.showMenuCreate;
      if (!this.showMenuCreate) this.processEdit = {};
    },
    async deleteComparison(id) {
      try {
        const result = await apiServices.delete(`procesoCompClima/${id}`);
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: `Se elimino correctamente.`,
            type: "is-link",
          });
          await this.getProcesses();
          this.$refs.modalCompClima.close();
        }
      } catch (error) {
        await this.$store.dispatch("notify", {
          message: `No se elimino correctamente la comparación.`,
          type: "is-danger",
        });
      }
    },
    editProcess(data) {
      this.processEdit = data;
      this.closeMenuCreate();
    },
    // Mobile actions (portadas desde buttonsActionProcess.vue para la vista de
    // tarjetas en móvil; la tabla ag-Grid de escritorio sigue usando su propio
    // cell renderer).
    async toggleActive(process) {
      try {
        const result = await apiServices.post("activecohorteclima", {
          idProcess: process._id,
          newStatus: !process.active,
        });
        if (result.data) {
          const idx = this.processes.findIndex((p) => p._id === process._id);
          if (idx !== -1) {
            this.$set(this.processes, idx, {
              ...this.processes[idx],
              active: result.data.active,
            });
          }
          await this.$store.dispatch("notify", {
            message: `Se ha ${
              !process.active ? "habilitado" : "deshabilitado"
            } el proceso.`,
            type: "is-link",
          });
        }
      } catch (e) {
        await this.$store.dispatch("notify", {
          message: `Error al ${
            !process.active ? "habilitar" : "deshabilitar"
          } el proceso.`,
          type: "is-danger",
        });
      }
    },
    copyLinkProcess(process) {
      const textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = window.location.host + "/accesoclima/" + process.codigo;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand("copy");
        this.$store.dispatch("notify", {
          message: successful ? "¡Copiado al portapapeles!" : "Error al copiar",
          type: successful ? "is-link" : "is-danger",
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    async deleteProcess(process) {
      const config = {
        title: "¿Estás seguro?",
        text:
          "Al eliminar no se podrá recuperar el proceso después y se eliminarán todos los empleados.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const deleteAttached = this.$fire.deleteFolderAttached(process._id);
            if (!deleteAttached) {
              await this.$store.dispatch("notify", {
                message: "Error al eliminar los anexos.",
                type: "is-danger",
                duration: 4000,
                position: "top-center",
              });
            } else {
              const res = await apiServices.delete(
                `/deletecohorteclima/${process._id}`,
              );
              if (res.data) {
                await this.$swal({
                  text: "Proceso eliminado correctamente.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1700,
                });
                this.getProcesses();
              }
            }
          } catch (err) {
            await this.$swal({
              text: "Error al eliminar el proceso.",
              icon: "error",
              showConfirmButton: false,
              timer: 1700,
            });
            console.log(err);
          }
        }
      });
    },
    // Helpers
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    formatTypeProcess(p) {
      if (!p.data.benchmark) return "";
      return `<span class="tag tag-process is-success is-capitalized"><i class="mdi mdi-database-import-outline"></i></span>`;
    },
    formatStatusComp(v) {
      const n = v ? v.length : 0;
      if (n > 0) {
        return `<span class="tag is-dark">${n}</span>`;
      }
      return `<span class="tag is-warning is-capitalized">No</span>`;
    },
  },
  created() {
    if (this.idtoken) {
      this.getProcesses();
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getProcesses();
      }
    },
  },
  components: {
    ModalComparacionHistorico,
    MenuCreateProcess,
    tableAg,
    ProcessCardsMobile,
  },
};
</script>
<style lang="scss">
.ag-pre-table .ag-header-cell-label {
  justify-content: center !important;
}

.slideCustom-enter {
  transform: translateX(30vw);
}

.slideCustom-enter-active {
  transition: all 0.3s ease-in;
}

.slideCustom-leave-active {
  transition: all 0.3s ease-in;
}
.slideCustom-leave-to {
  transform: translateX(30vw);
}

.slideCustom-two-enter {
  transform: translateX(30vw);
}

.slideCustom-two-enter-active {
  transition: all 0.3s ease-in;
}

.slideCustom-two-leave-active {
  transition: all 0.3s ease-in;
}
.slideCustom-two-leave-to {
  transform: translateX(30vw);
}

.tag-process {
  font-size: 11px !important;
  margin-right: 5px;
}

.process .tag-process {
  margin-right: 5px;
  height: auto !important;
  font-size: 17px !important;
  padding-left: 0.35em !important;
  padding-right: 0.35em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Process.vue